import React from 'react';

function Apoio() {
    return (
        <section id="apoio-ao-estudante">
            <p class="anchor" id="apoio"></p>
            <div className="container wow fadeIn">
                <div className="row">
                    <div className="col-lg-12 text-center text-lg-left">
                        <h3 className="cta-title">Apoio ao estudante</h3>
                        <p className="cta-text">Repositório com o Banco de Apontamentos, Banco de Erasmus e Banco de Sebentas</p>
                    </div>
                    <div className="cta-btn-container text-center" style={{marginLeft: "15px"}}>
                        <a className="cta-btn align-middle" href="https://drive.google.com/drive/folders/0B9ZemdYVZdeDZjhsWGJ6dWhTTHc">Banco de Apontamentos - L.EQ</a>
                    </div>
                    <div className="cta-btn-container text-center" style={{marginLeft: "15px"}}>
                        <a className="cta-btn align-middle" href="https://drive.google.com/drive/folders/1eZTm6EiEWDPsiMgHUSDMUDgWq-XfHmqm">Banco de Apontamentos - M.EQ</a>
                    </div>
                    <div className="col-lg-4 cta-btn-container text-center">
                        <a className="cta-btn align-middle" href="https://drive.google.com/drive/folders/1Cxu0DCvz6sWZa86lMg0x-JmwGQ8LWYW_">Banco de Erasmus</a>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Apoio;